import { SINGLE_CHOICE_IMAGE, MULTIPLE_CHOICE_IMAGE } from 'constants/questionTypes';
import { getQuestion } from 'store/questions/selectors';
import { isRandomizeAnswersEnabled } from 'store/settings/selectors';
import { RootAppState } from '../../types';

export const getUserAnswers = (state: RootAppState, questionId: string) => {
  const question = getQuestion(state, questionId);
  const randomizeAnswersEnabled = isRandomizeAnswersEnabled(state);
  const { answers: options, randomizedOptions = [] } = question;
  const answers = randomizeAnswersEnabled ? randomizedOptions : options;
  if (question.type === SINGLE_CHOICE_IMAGE || question.type === MULTIPLE_CHOICE_IMAGE) {
    return answers.map((answer: any) => ({
      id: answer.id,
      image: answer.image,
      altText: answer.altText,
      selected: question.response.some((a: any) => a === answer.id)
    }));
  }
  return answers.map((answer: any) => ({
    id: answer.id,
    isCorrect: answer.isCorrect,
    text: answer.text,
    selected: question.response.some((a: any) => a === answer.id)
  }));
};

export const getScore = (state: RootAppState, question: any) => {
  if (question.type === SINGLE_CHOICE_IMAGE) {
    if (!question.response.includes(question.correctAnswerId)) {
      return 0;
    }
  } else {
    for (const answer of question.answers) {
      if (answer.isCorrect && !question.response.includes(answer.id)) {
        return 0;
      }
      if (!answer.isCorrect && question.response.includes(answer.id)) {
        return 0;
      }
    }
  }

  return 100;
};

export const isAttempted = (question: any) => !!question.response?.length;
